import React from 'react'
import {
    HiOutlineDocumentDuplicate,
    HiOutlineHome,
    HiOutlineOfficeBuilding,
    HiOutlineTruck,
} from 'react-icons/hi'
import { SiDatabricks } from 'react-icons/si'

const menuItems = [
    {
        id: 0,
        label: 'Dashboard',
        module: 'home',
        link: '/',
        icon: <HiOutlineHome size={20} />,
    },
    {
        id: 1,
        label: 'Company Management',
        module: 'company-management',
        icon: <HiOutlineOfficeBuilding size={20} />,
        children: [
            {
                id: 11,
                label: 'Company',
                module: 'company',
                link: '/company-management/company',
            },
            {
                id: 12,
                label: 'Company Configuration',
                module: 'company-configuration',
                link: '/company-management/company-configuration',
            },
            {
                id: 13,
                label: 'Company Admin',
                module: 'company-admin',
                link: '/company-management/company-admin',
            },
            {
                id: 14,
                label: 'Company User',
                module: 'company-user',
                link: '/company-management/company-user',
            },
            {
                id: 15,
                label: 'Client Company',
                module: 'client-company',
                link: '/company-management/client-company',
            },
        ],
    },
    {
        id: 2,
        label: 'Transport Service Provider',
        module: 'transport-service-provider',
        icon: <HiOutlineTruck size={20} />,
        children: [
            {
                id: 21,
                label: 'Transport Provider',
                module: 'transport-provider',
                link: '/transport-service-provider/transport-provider',
            },
            {
                id: 22,
                label: 'Transport Provider Admin',
                module: 'transport-provider-admin',
                link: '/transport-service-provider/transport-provider-admin',
            },
            {
                id: 23,
                label: 'Transport Provider User',
                module: 'transport-provider-user',
                link: '/transport-service-provider/transport-provider-user',
            },
            {
                id: 24,
                label: 'Transport Provider Service',
                module: 'transport-provider-service',
                link: '/transport-service-provider/transport-provider-service',
            },
            {
                id: 25,
                label: 'Transport Rate Calculator',
                module: 'transport-rate-calculator',
                link: '/transport-service-provider/transport-rate-calculator',
            },
        ],
    },
    {
        id: 3,
        label: 'Master Data',
        module: 'master-data',
        icon: <SiDatabricks size={20} />,
        children: [
            {
                id: 31,
                label: 'Rate Card Management',
                module: 'rate-card',
                link: '/master-data/rate-card',
            },
            {
                id: 32,
                label: 'Extra Charges',
                module: 'extra-charges',
                link: '/master-data/extra-charges',
            },
            {
                id: 33,
                label: 'Fuel Levy',
                module: 'fuel-levy',
                link: '/master-data/fuel-levy',
            },
            {
                id: 34,
                label: 'Formula Template',
                module: 'formula-template',
                link: '/master-data/formula-template',
            },
            {
                id: 35,
                label: 'Assign',
                module: 'assign',
                link: '/master-data/assign',
            },
        ],
    },
    {
        id: 4,
        label: 'Invoices',
        module: 'invoices',
        icon: <HiOutlineDocumentDuplicate size={20} />,
        children: [
            {
                id: 41,
                label: 'Upload Invoices',
                module: 'upload-invoices',
                link: '/invoices/upload-invoices',
            },
            {
                id: 42,
                label: 'Verified Invoices',
                module: 'verified-invoices',
                link: '/invoices/verified-invoices',
            },
            {
                id: 43,
                label: 'Pending Invoices',
                module: 'pending-invoices',
                link: '/invoices/pending-invoices',
            },
            {
                id: 44,
                label: 'Approved Invoices',
                module: 'approved-invoices',
                link: '/invoices/approved-invoices',
            },
            {
                id: 45,
                label: 'Rejected Invoices',
                module: 'rejected-invoices',
                link: '/invoices/rejected-invoices',
            },
        ],
    },
]

export default menuItems
